import { render, staticRenderFns } from "./FaucetGet.vue?vue&type=template&id=488ad1aa&"
import script from "./FaucetGet.vue?vue&type=script&lang=js&"
export * from "./FaucetGet.vue?vue&type=script&lang=js&"
import style0 from "./FaucetGet.vue?vue&type=style&index=0&id=488ad1aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports